import { defineMessages } from '@transcend-io/internationalization';

export const revokeRequestMessages = defineMessages(
  'privacy-center.containers.RevokeRequest.revokeRequest',
  {
    revoke: {
      defaultMessage: 'Cancel Request',
    },
    sure: {
      defaultMessage: 'Are you sure you want to cancel this request?',
    },
  },
);
